import ActionTypes from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: null,
  item: null,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.MONTHLY_REPORT_FETCH:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ActionTypes.MONTHLY_REPORT_FETCH__SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        item: payload.item,
      };
    case ActionTypes.MONTHLY_REPORT_FETCH__FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    default:
      return state;
  }
};

